import { render, staticRenderFns } from "./ChoiceValueFormRowTemplate.vue?vue&type=template&id=059f84b4&scoped=true"
import script from "./ChoiceValueFormRowTemplate.vue?vue&type=script&lang=js"
export * from "./ChoiceValueFormRowTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f84b4",
  null
  
)

export default component.exports